import React, { Component } from 'react';
import {
    Row,
    Col,
    List
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import simbaIcon from '../../assets/logo/512x512simba.png'
import imgBtnAppStore from "../../assets/icon/home/Footer/AppStore.svg"
import imgBtnPlayStore from "../../assets/icon/home/Footer/GooglePlay.svg"
import linkedinIcon from "../../assets/icon/home/Footer/Linkedin.svg"
import facebookIcon from "../../assets/icon/home/Footer/Facebook.svg"
import instagramIcon from "../../assets/icon/home/Footer/Instagram.svg"
import youtubeIcon from "../../assets/icon/home/Footer/Youtube.svg"
import tiktokIcon from '../../assets/icon/home/Footer/TikTok.svg';
import XIcon from '../../assets/icon/home/Footer/X.svg';


import "../../css/footer.css"

export default class DefaultFooter extends Component {
    constructor() {
        super()
        this.state = {
            screenWidth: window.innerWidth,
            selectedTab: 'prepaid'
        }
    }

    componentDidMount() {
        this.setState({ currentYear: new Date().getFullYear() })
    }

    render() {
        const { screenWidth } = this.state;
        const isDataOnlySimPage = window.location.pathname === "/data-only";
        const isHomePage = window.location.pathname === "/home";
        const isBroadband = window.location.pathname === "/broadband"
        const isBroadbandMoreInfo = window.location.pathname === "/broadband/10Gbps-broadband-what-you-need-to-know"
        const isBroadbandWalkIn = window.location.pathname === "/broadband/walk-in"
        const isPrepaid = window.location.pathname === "/personal-prepaid"
        const isSmallScreen = screenWidth <= 995;
        const isBusiness = window.location.pathname === "/business-plan"
        const isBusinessDevice = window.location.pathname === "/broadband/devices"
        const isBroadbandTrust = window.location.pathname === "/promo/trust"
        const isBroadbandCIS = window.location.pathname === "/cis-broadband"
        const isBroadbandTerms = window.location.pathname === "/cis-broadband"
        

        const isBroadbandPath = isBroadband || isBroadbandMoreInfo || isBroadbandWalkIn || isBusinessDevice || isBroadbandTrust || isBroadbandCIS || isBroadbandTerms;

        return (
            <footer className="footer bg-white py-3 px-3" style={{ overflowX: 'hidden' }}>
                <Row className='px-2'>
                    {!isHomePage && 
                        <Row style={{ justifyContent: 'center', textAlign: 'center', marginBottom: 10 }}>
                            <Col lg={8} md={8} xs={12}>
                                <a className="text-link non-underline-link" href="https://support.simba.sg/" style={{ fontSize: 13 }}>FAQ</a>
                                <span style={{ fontSize: '18px', margin: '0 10px' }}>|</span>
                                <a className="text-link non-underline-link" href={isBroadbandPath  ? "/cis-broadband?tab=10Gbpsbroadband" : isPrepaid ? "/cis?tab=prepaid" : isBusiness ? "/cis?tab=business" : "/cis?tab=postpaid"}  style={{ fontSize: 13 }}>Critical Information Summary</a>
                                <span style={{ fontSize: '18px', margin: '0 10px' }}>|</span>
                                <a href={isBroadbandPath  ? "https://simba.sg/static/media/fbb/assets/FBBTerms.pdf" : "/terms"} className="text-link non-underline-link" style={{ fontSize: 13 }} target={isBroadbandPath  ? "_blank" : "_self"}> Terms and Conditions </a>
                            </Col>
                        </Row>
                    }

                    <Col lg={6} md={6} sm={12} xs={12} style={{ marginBottom: 10, marginTop: 20, display: 'flex', flexWrap: 'wrap', justifyContent: isSmallScreen ? 'center' : 'flex-start', alignItems: isSmallScreen ? 'center' : 'flex-start', flexDirection: 'column', textAlign: isSmallScreen ? 'center' : 'start' }} >
                        <span style={{ marginBottom: isSmallScreen ? '10px' : '0' }}>Follow us:</span>
                        <Col lg={4} md={6} sm={6} xs={12} style={{ display: 'flex', justifyContent: isSmallScreen ? 'center' : 'flex-start', alignItems: isSmallScreen ? 'center' : 'start', flexDirection: 'row', flexWrap: 'nowrap' }}>
                            {[
                                { href: "https://www.linkedin.com/company/simbatelecom/", icon: linkedinIcon },
                                { href: "https://www.facebook.com/SIMBAtelecomSG", icon: facebookIcon },
                                { href: "https://www.tiktok.com/@simbatelecomsg", icon: tiktokIcon },
                                { href: "https://x.com/SimbaTelecomSG", icon: XIcon },
                                { href: "https://www.instagram.com/simbatelecomsg/", icon: instagramIcon },
                                { href: "https://www.youtube.com/channel/UCzFUkVZ0Q_fJGGpw7cEU0cg", icon: youtubeIcon }
                            ].map(({ href, icon }, index) => (
                                <a key={index} href={href}>
                                    <img src={icon} style={{ marginTop: -5 }} width="50" />
                                </a>
                            ))}
                        </Col>
                    </Col>
                    {!isHomePage && !isBroadband && (
                        <>
                            <Col lg={6} md={6} sm={12} xs={12} style={{ marginBottom: 30, marginTop: 20, display: 'flex', justifyContent: 'flex-end' }}>
                                <Row style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                                    <Col style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: isSmallScreen ? 'center' : 'flex-end' }}>
                                        <img src={simbaIcon} style={{ width: 80, height: 80, border: '1px solid #BACBD5', borderRadius: '8px', marginRight: 10 }} />
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                            <div style={{ fontSize: 14, fontWeight: 700, textAlign: 'left', width: '100%' }}>
                                                Download My SIMBA App
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                                                <a href="https://apps.apple.com/sg/app/tpg-sg/id1542566692">
                                                    <img src={imgBtnAppStore} style={{ height: 40, marginRight: 10 }} />
                                                </a>
                                                <a href="https://play.google.com/store/apps/details?id=com.tpg_sg">
                                                    <img src={imgBtnPlayStore} style={{ height: 40 }} />
                                                </a>
                                            </div>
                                        </div>

                                    </Col>
                                </Row>
                            </Col>
                        </>
                    )}
                    <hr />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <p style={{ fontSize: 13, margin: 0 }}>Copyright © 2025 SIMBA Telecom Pte Ltd (UEN: 201617990D)</p>
                        <NavLink className="text-link non-underline-link" to="/data-protection-notice" style={{ fontSize: 13 }}>Data Protection Notice</NavLink>
                    </div>
                </Row>
            </footer>
        )
    }
}